import IDMGlobals from './../IDMGlobals';
import URLQuery,{ getUrlParams } from 'query-string-manipulator';
const base64 = require('base-64');
/**
 *
 */
export default class IDMAuthenticator {
  /**
   * constructor - description
   *
   * @param  {type} datasource description
   * @return {type}            description
   */
  constructor(datasource) {
    this.datasource = datasource;
    this.isAutheticating = false; //used to limit revalidation engine to one validation at the time
  }

  async logout(optionalPostLogoutURL, keepQueryContext = true) {
    //Clear session
    await this.datasource.session.clearSession();
    //Check if provider is enabled, make oauth logout
    // ----- Possible improvement here would be detecting this by the JWT and not IDM wide!
    // ----- If improvement is implemented don't forget to replicate redirect behaviour for those
    // ----- who dont need fed. logout
    if (this.datasource.externalProviders.isExternalProvidersEnabled()) {
      //Persitent context logic
      const v = getUrlParams(window.location.href);
		  const suffix = (v && v.length > 0 && keepQueryContext ? base64.encode(JSON.stringify(v)) : '');
      //Persistent context BUGFIX Logic (OPD-335) - 'Might have other occureces in the code'
      if (suffix != '') await this.datasource.session.data.storage.setDefaultValue(IDMGlobals.CookiesKey_IDMLogoutStateBugfix, suffix);

      //Init oauth
      const resp = await this.datasource.api.externalProvider.getExternalProviderLogoutURL(optionalPostLogoutURL || window.location.origin, suffix);
      if (resp && resp.statusCode == 200 && resp.body.url) {
        window.location = resp.body.url;
        return true;
      }
    } 
  }

  async login(username, password, optionalMFAOrOptionalRole, callbackURL, optContext) {
    //check if client want to authenticate externally
    if (this.datasource.opts.externalAuth) {
      //remember me cannot be used here as we rely on saved cookies to make the communication
      await this.datasource.urlmanager.redirectRequest(this.datasource.opts.externalAuthDomain,
                                                       this.datasource.opts.externalAuthPath,
                                                       username, optionalMFAOrOptionalRole, (window.location || callbackURL), optContext);
    } else {
      this.isAutheticating = true;
      //request authentication
      const timestamp = Date.now();
      const resp = await this.datasource.api.authorization.login(username, password, optionalMFAOrOptionalRole, this.datasource.impersonate.getRole(), timestamp);
      if (!this.datasource.opts || !this.datasource.opts.disableLogs) console.debug("Login resp: ", resp)
      //internall processing
      await this.datasource.handleAuthenticationResponse(resp, username, false);
      this.isAutheticating = false;
      //return response for user
      return resp;
    }
  }

  async validate(token, username, forceAPI, callbackURL, optContext) {
    //check if client want to authenticate externally
    if (this.datasource.opts.externalAuth && !forceAPI) {
      await this.datasource.urlmanager.redirectRequest(this.datasource.opts.externalAuthDomain,
                                                       this.datasource.opts.externalValidatePath,
                                                       null, null, (window.location || callbackURL), optContext);
    } else {
      this.isAutheticating = true;
      //request revalidation
      const timestamp = Date.now();
      const resp = await this.datasource.api.authorization.validate(token, username, timestamp);
      if (!this.datasource.opts || !this.datasource.opts.disableLogs) console.debug("Validation resp: ", resp)
      //internall processing
      await this.datasource.handleAuthenticationResponse(resp, null, true);
      this.isAutheticating = false;
      //return response for user
      return resp;
    } return null;
  }

  /* Federation */
  async loginFederationWithCode(code, redirectURL) {
    this.isAutheticating = true;
    //request federated login
    const resp = await this.datasource.api.authorization.loginFederation(code, redirectURL, this.datasource.impersonate.getRole());
    if (!this.datasource.opts || !this.datasource.opts.disableLogs) console.debug("Federation resp: ", resp)
    //internall processing
    await this.datasource.handleAuthenticationResponse(resp, null, false);
    this.isAutheticating = false;
    //return response for user
    return resp;
  }
  /* SSO */
  async loginSSOWithCode(code) {
    //Ideally we should check if the JWT on the authorization response will have 
    //the this.datasource.impersonate.getRole(), if not, enroll and revalidate! -- for now it's a 'SSO limitation'
    this.isAutheticating = true;
    //request federated login
    const resp = await this.datasource.api.authorization.loginSSO(code);
    if (!this.datasource.opts || !this.datasource.opts.disableLogs) console.debug("SSO resp: ", resp)
    //internall processing
    await this.datasource.handleAuthenticationResponse(resp, null, false);
    this.isAutheticating = false;
    //return response for user
    return resp;
  }
  /* MFA */
  async respondToMFAAndLogin(username, srpID, context, code) {
    this.isAutheticating = true;
    //request federated login
    const resp = await this.datasource.api.authorization.answerChallenge({
      challengeState: IDMGlobals.AuthorizationChallengeState_SMSMFARequired,
      challengeContext: context, code, username, srpID
    });
    if (!this.datasource.opts || !this.datasource.opts.disableLogs) console.debug("MFA/Login resp: ", resp)
    //internall processing
    await this.datasource.handleAuthenticationResponse(resp, username, false);
    this.isAutheticating = false;
    //return response for user
    return resp;
  }
}
